import { render, staticRenderFns } from "./User2.vue?vue&type=template&id=39ac75e2&"
import script from "./User2.vue?vue&type=script&lang=js&"
export * from "./User2.vue?vue&type=script&lang=js&"
import style0 from "./User2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports